import React, { Component } from 'react'
import Cookies from "js-cookie";
import Text from './Text'
import Boolean from './Boolean'
import Button from "components/CustomButtons/Button.jsx";
import { Dialog, DialogActions, DialogContent, withStyles } from '@material-ui/core'
import { connect } from 'react-redux';
import { mapDispatchToProps, mapStateToProps } from 'framework/utils/Redux';
import { tl } from 'framework/utils/Translator';
import moment from 'moment-timezone';

class DebugHost extends Component {
    constructor(props){
        super(props)
        this.state = {
            open:false,
            host:Cookies.get("debugHost") || props.Session?.host || "",
            customHost:Cookies.get("customHost") == "true" ? true : false
        }
    }

    componentDidMount(){
        document.addEventListener("keydown", this.handleKeydown)
    }

    handleKeydown = (event) => {
        if (event.altKey && (event.key === 'h' || event.key === 'H')) {
            event.preventDefault();
            // toggle the debug dialog (or set open: true to always open)
            this.setState(prev => ({ open: !prev.open }));
        }
    }

    handleClose = () => {
        this.setState({
            open:false
        })
    }

    handleHostChange = (field, value) => {
        this.props.setHost(value);
        Cookies.set("debugHost", value, { path: "/", expires: moment().add(1, "year").toDate() });
        this.setState({
            host:value
        })
    }

    toggleCustomHostChange = (field, value) => {
        if (value) {
            Cookies.set("customHost", value.toString(), { path: "/", expires: moment().add(1, "year").toDate() });
        } else {
            Cookies.remove("customHost")
        }
    }

    render() {
        const {classes} = this.props
        return (
            <div >
                <Dialog open={this.state.open} onClose={this.handleClose}>
                    <DialogContent style={{padding:"10px", paddingTop:"20px"}}>
                        <div className={classes.wrapperNew} style={{width:"360px", fontFamily:"Quicksand !important"}}>
                            <div style={{padding:'0px 12px'}}>
                                <Text
                                    field="debugHost"
                                    label="Host"
                                    value={this.state.host}
                                    renderMode="formEdit"
                                    onChange={this.handleHostChange}
                                />
                            </div>
                            <Boolean
                                
                                inlineLabel
                                renderMode="formEdit"
                                field="customHost"
                                label="Custom Host"
                                value={this.state.customHost}
                                onChange={this.toggleCustomHostChange}
                            />
                        </div>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={()=>this.handleClose()} size="sm">{tl("cancel")}</Button>
                        <Button color="success" size="sm" onClick={()=>this.handleClose()}>OK</Button>
                    </DialogActions>
                </Dialog>
            </div>
        )
    }
}

const style = {
    wrapperNew:{
        display: 'flex',
        flexDirection: 'column',
        gap:'5px',
        "& label":{
            fontFamily: "Quicksand !important",
            fontSize: "0.8rem !important",
            fontWeight: "bold !important",
            color: "#849290 !important"
        },
        "& .basic-input-container":{
            backgroundColor: "#f7f7f7",
            height: "35px",
            padding: "3px 4px",
            borderRadius: "20px",
            display: "flex",
            border: "1px solid #dedede",
            boxShadow: "0px 0px 3px rgba(3, 169, 244, 0)",
            transition: "0.3s ease-in-out",
            "&:focus-within":{
                boxShadow: "0px 0px 3px rgba(3, 169, 244, 1)"
            }
        },
        "& input":{
            padding:"1px 10px 0px",
            fontFamily: "Quicksand",
            fontSize: "0.9rem",
            color: "#000"
        }
    }
}

export default withStyles(style)(connect(mapStateToProps, mapDispatchToProps)(DebugHost))